import { render, staticRenderFns } from "./windowCom.vue?vue&type=template&id=0610ffda&"
import script from "./windowCom.vue?vue&type=script&lang=js&"
export * from "./windowCom.vue?vue&type=script&lang=js&"
import style0 from "./windowCom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "windowCom.vue"
export default component.exports